// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__3zEeu","form":"EditListingDescriptionPanel_form__3vtLn","title":"EditListingDescriptionPanel_title__2zE4U"};